import type { Form } from 'formik'
import { Field } from 'formik'
import { AsyncPaginate } from 'react-select-async-paginate'

import extendedReactSelectStyles from './extendedStyles'
import reactSelectStyles from './styles'
import type {
  PaginatedQueryParams,
  PaginatedResponse,
} from '../../../store/types'
import type { DropdownOption } from '../types'

// must take fetcher and count to work
const SelectAsyncPaginate = ({
  fetcher,
  onChange,
  defaultValue,
  form,
  field,
  customComponent,
  seperator,
  setSeperator,
  styles,
  customHeight,
  extendedStyles,
  ...rest
}: {
  fetcher: { (args: PaginatedQueryParams): Promise<PaginatedResponse<any>> }
  onChange: { (opt: DropdownOption | null): Promise<any> }
  form: typeof Form
  field: typeof Field
  defaultValue: DropdownOption
  customComponent?: boolean
  seperator?: string
  setSeperator?: any
  styles?: any
  customHeight?: string
  extendedStyles?: boolean
}) => {
  const loadOptions: any = async (
    search: string,
    loadedOptions: any,
    { page, hasMore }: { page: number; hasMore: boolean },
  ) => {
    try {
      const normalizedSearch = search.replace(/—/g, '-')
      const { data, meta } = await fetcher({
        page,
        limit: 10,
        search: normalizedSearch,
      })
      return {
        options: data,
        hasMore: meta.page < meta.totalPages,
        additional: {
          page: meta.page + 1,
        },
      }
    } catch (error) {
      return {
        options: [],
        hasMore: false,
        additional: {
          page: 1,
        },
      }
    }
  }

  return (
    <AsyncPaginate
      className={`w-full text-sm font-semibold ${customHeight && customHeight}`}
      loadOptions={loadOptions}
      onChange={(opt: DropdownOption | null) => {
        onChange?.(opt)
      }}
      defaultValue={defaultValue || null}
      isSearchable={true}
      styles={
        styles ? styles : extendedStyles ? reactSelectStyles : reactSelectStyles
      }
      additional={{
        page: 1,
        hasMore: true,
      }}
      {...rest}
    />
  )
}

export default function AsyncPaginatedDropdown(props: any) {
  if (props.name) {
    return <Field {...props} component={SelectAsyncPaginate} />
  }
  return <SelectAsyncPaginate {...props} />
}
